import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { GameRoom } from '../api.types';
import { GameApiService } from '../game-api.service';

@Component({
  selector: 'ag-play',
  standalone: true,
  imports: [FormsModule, RouterLink],
  templateUrl: './play.component.html',
  styleUrl: './play.component.css'
})
export class PlayComponent {
  hostName = 'Living Room';
  readonly room = signal<GameRoom | null>(null);

  constructor(private readonly gameApi: GameApiService) {}

  createRoom(): void {
    this.gameApi.createRoom(this.hostName).subscribe((room) => this.room.set(room));
  }
}
